import Vue from 'vue';
import Router from 'vue-router';
import index from '@/view/index';

Vue.use(Router);

export default new Router({
  mode: 'history', //去掉url中的#
  routes: [
    {
      path: '/',
      component: index,
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/index',
      component: index,
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/scheme',
      component: () => import('@/view/scheme'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/show',
      name: 'show',
      component: () => import('@/view/show'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/contact',
      component: () => import('@/view/contact'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/join',
      component: () => import('@/view/join'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/laboratory',
      name: 'laboratory',
      component: () => import('@/view/laboratory'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/action',
      component: () => import('@/view/action'),
      meta: {
        title: '墨客云科技',
      },
    },
    {
      path: '/laboratorys',
      component: () => import('@/view/laboratorys'),
      meta: {
        title: '墨客云科技',
      },
    },
  ],
  title: '墨客云科技',
});



// WEBPACK FOOTER //
// ./src/router/index.js